import { render, staticRenderFns } from "./Placanje.vue?vue&type=template&id=dd1eff70&"
import script from "./Placanje.vue?vue&type=script&lang=js&"
export * from "./Placanje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports